import cn from 'classnames';
import { 
  Swiper, 
  SwiperSlide,
} from 'swiper/react';
 import { 
  Pagination,
  Autoplay,
} from 'swiper/modules';

import styles from './Dev.module.css';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';

const SophieSliderContent = () => (
  <div className={styles.userSayContent}>
    <div className={styles.userSayInfo}>
      <div className={styles.userSayStars}>
         ⭐⭐⭐⭐⭐
      </div>
      <div className={styles.userSaySubTitle}>
        “Meal Well has completely changed how I eat during the week. I love the variety, and the AI meal plans actually feel like they were made for me!”
      </div>
      <div className={styles.userSaySubTitle}>
        — Sophie L., London
      </div>
    </div>
  </div>
);

const JamesSliderContent = () => (
  <div className={cn(styles.userSayContent, styles.jamesSlide)}>
    <div className={styles.userSayInfo}>
      <div className={styles.userSayStars}>
         ⭐⭐⭐⭐⭐
      </div>
      <div className={styles.userSaySubTitle}>
        “I used to stress over what to cook every day. Now I just follow the plan, and it’s quick, healthy, and tastes amazing.”
      </div>
      <div className={styles.userSaySubTitle}>
        — James T., Manchester
      </div>
    </div>
  </div>
);

const AminaSliderContent = () => (
  <div className={cn(styles.userSayContent, styles.aminaSlide)}>
    <div className={styles.userSayInfo}>
      <div className={styles.userSayStars}>
         ⭐⭐⭐⭐⭐
      </div>
      <div className={styles.userSaySubTitle}>
        “The step-by-step videos are a game changer. I’ve learned so much and finally enjoy cooking again.”
      </div>
      <div className={styles.userSaySubTitle}>
        — Amina R., Birmingham
      </div>
    </div>
  </div>
);

const UsersSaysSection = () => {
  return (
    <section className={cn(styles.section, styles.userSaySection)}>
      <div className={styles.sectionTitle}>
        What Our Users Say
      </div>
      <div className={styles.userSayWrapper}>
        <Swiper 
          modules={[Pagination, Autoplay]}
          className={styles.slider} 
          spaceBetween="24" 
          slidesPerView="1" 
          navigation
          pagination={{ 
            clickable: true,
          }}
          autoplay={{ 
            delay: 3000,
            disableOnInteraction: false,
          }} 
          // loop   
        >
          <SwiperSlide className={styles.loveSliderSlide}>
            <SophieSliderContent />
          </SwiperSlide>
          <SwiperSlide className={styles.loveSliderSlide}>
            <JamesSliderContent />
          </SwiperSlide>
          <SwiperSlide className={styles.loveSliderSlide}>
            <AminaSliderContent />
          </SwiperSlide>
        </Swiper>
      </div>
    </section>
  );
};

export default UsersSaysSection;
